
<template>
  <div style="width:100%;height:100%;" class="mainMap" :id="zzMapId">
  </div>
</template>
<script>
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import './libs/index'
import Popup from './map-popup/index'
Vue.use(Popup)

Vue.prototype.$event = Vue.prototype.$event || new Vue()
export default {
  name: 'mainMap',

  props: {
    // 可以创建多个地图对象
    mapid: {
      type: String
    },
    isloadData: {
      type: Boolean,
      default: true
    },
    istoolbar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: true,
      zzMapId: this.mapid || 'mapDiv_' + Math.ceil(Math.random() * 10000),
      mapoptins: this.mapOptins,
      mainMap: null,
      mapNavbar: null,
      map_Center: [27.842398471, 113.154482025]
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        this.map_Center = city[i].mapCenter
      }
    }
    this.$nextTick(() => {
      if (this.mapoptins === undefined) {
        this.mapoptins = {
          mapcrs: null,
          center: this.map_Center,
          zoomLevel: 12,
          zoomControl: true,
          visibleContextmenu: true

        }
      }
      if (this.zzMapId === undefined) this.zzMapId = 'mapDiv_' + Math.ceil(Math.random() * 10000)
      // 创建地图容器对象
      this.createMap(this.zzMapId, this.mapoptins)
      // 地图容器创建完成，触发initMapCompleteEvent事件

      const imgm = L.tiandituTileLayer({ layerType: 'img', key: '1d109683f4d84198e37a38c442d68311' })
      const imga = L.tiandituTileLayer({ layerType: 'cia', key: '1d109683f4d84198e37a38c442d68311' })
      this.mainMap.addLayer(imgm)
      this.mainMap.addLayer(imga)
      this.$emit('ready', this.mainMap)
    })
  },
  mounted() {
    //
  },
  methods: {
    createMap(mapDivid, mapOptins) {
      const c = Math.PI * 2 * 6378137
      const halfC = c / 2
      // eslint-disable-next-line camelcase
      const tdt_Mercator_resolutions = []
      for (let i = 1; i < 19; i++) {
        tdt_Mercator_resolutions.push(c / 256 / Math.pow(2, i))
      }
      // eslint-disable-next-line camelcase
      const TianDiTu_MercatorCRS = new L.Proj.CRS('EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs',
        {
          origin: [-halfC, halfC],
          resolutions: tdt_Mercator_resolutions,
          bounds: L.bounds([-halfC, -halfC], [halfC, halfC]),
          wrapLng: [-180, 180]
        })
      this.mainMap = L.map(mapDivid, {
        crs: TianDiTu_MercatorCRS,
        center: mapOptins.center,
        attributionControl: false,
        doubleClickZoom: false,
        closePopupOnClick: false,
        zoom: mapOptins.zoomLevel,
        maxZoom: 17,
        minZoom: 7,
        zoomControl: mapOptins.zoomControl,
        contextmenu: mapOptins.visibleContextmenu, // 地图右键
        contextmenuWidth: 140,
        contextmenuItems: mapOptins.contextmenuItemsAry
      })
      const importLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.importLayerGroup = importLayerGroup
    }

  }
}
</script>

<style scoped>
.mainMap {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: default;
  position: relative;
}
.cursor-draw {
  cursor: url('./cur/draw.cur'), auto !important;
}

.cursor-identify {
  cursor: url('./cur/identify.cur'), auto !important;
}

.cursor-measure {
  cursor: url('./cur/measure.cur'), auto !important;
}

.cursor-zoomout {
  cursor: url('./cur/zoomout.cur'), auto !important;
}

.cursor-zoomin {
  cursor: url('./cur/zoomin.cur'), auto !important;
}

.cursor-pan {
  cursor: url('./cur/pan_over.cur'), auto !important;
}
</style>
